//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

// custom pages
import { availablePointsStyles } from '../styles';
import Context from 'context/context';
import { pointsFormat } from 'helpers/dataFormat';
import DashboardAPI from 'apis/dashboard/dashboard';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { withStyles } from '@material-ui/styles';
import { logEvent } from '../../../../helpers/analytics'; // <-- import logEvent
import {useTrackWithGTM} from 'helpers/gtm';
import Tooltip from '@material-ui/core/Tooltip';


// material-ui
import Grid from '@material-ui/core/Grid';

export default function AvailablePoints({ loyaltyActive }) {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const classes = availablePointsStyles();
  const { getPoints } = DashboardAPI();
  const { t, i18n } = useTranslation();

  const [points, setPoints] = useState({});
  const { trackWithGTM } = useTrackWithGTM()
  // handling get points api call
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      handleGetPoints();
      return;
    }
  }, [state.ALA]);

  // get points api func
  const handleGetPoints = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      let values = state.ALA.loyalty_id;
      let res = await getPoints(values);
      if (res) {
        setPoints(res);
        dispatch({ type: 'SET_LOADING', payload: false });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let GreenTooltip;

  if (points?.availableToRedeem === 0 && points?.pointsBalance > 0) {
    GreenTooltip = withStyles({
      tooltip: {
        color: "black",
        backgroundColor: "#f6f9fc",
        width: "500px",
        fontSize: "12px",
      },
      arrow: {
        "&:before": {
          backgroundColor: "#f6f9fc",
        },
      },
    })(Tooltip);
  }

  if (points?.availableToRedeem > 0 && points.availableToRedeem < points.pointsBalance) {
    GreenTooltip = withStyles({
      tooltip: {
        color: "black",
        backgroundColor: "#e8eaeb",
        width: "500px",
        fontSize: "12px",
      },
      arrow: {
        "&:before": {
          backgroundColor: "#e8eaeb",
        },
      },
    })(Tooltip);
  }

  const redeembtnConditionForBronze = state?.userInfo?.role_id == null && (state?.ALA?.["Loyalty_Account.tier"]?.toLowerCase() == "bronze") && sessionStorage.getItem('redeemBtnDisabled') != null;

  // Analytics function for Redeem button
  const handleRedeemClick = () => {
    // Log analytics
    logEvent({
      event_type: "button_click",
      event_name: "Redeem Points",
      user_id: state?.userInfo?.user_id || null,
      session_id: state?.userInfo?.session_id || null,
      timestamp_client: Date.now(),
    });
    trackWithGTM({
      database: state?.userInfo?.loyalty_organization_name,
      event: "click",
      pathname: window.location.pathname,
      userId: state?.userInfo?.user_id,
      role_id:state?.userInfo?.role_id,
      allstate:state
    });

    // Navigate to redeem page
    history.push("/dashboard/redeem");
  }

  

  
  

 
  return (
    <div className={classes.mainDiv}>
     <Grid
  container
  spacing={2}
  style={
    state?.userInfo?.role_id == null &&
    state?.ALA?.["Loyalty_Account.tier"]?.toLowerCase() === "bronze" &&
    (state?.ACA?.signature_flag == null || state?.ACA?.signature_flag === false) &&
    (state?.ACA?.startup_flag == null || state?.ACA?.startup_flag === false)
      ? { visibility: 'hidden' }
      : {}
  }
>
        <Grid item md={4} xs={12}>
          {state?.ALA?.["Loyalty_Account.loyalty_organization_name"] == "Henry Schein Dental" ? <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "10px",
            }}
          >
            {/* <div className={(loyaltyActive && !redeembtnConditionForBronze) ? classes.availableDiv : classes.availableDivOne}>
              <div>
                <div>
                  Points Available to
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 30 }}>
                  <div>Redeem</div>
                  <div>
                    {points?.availableToRedeem === 0 && points?.pointsBalance > 0 ? (
                      <><GreenTooltip title={t('Points may only apply to invoices made within the past 90 days.')} placement="bottom" arrow>
                        <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: 3 }} />
                      </GreenTooltip></>
                    ) : null
                    }
                    {points?.availableToRedeem > 0 && points.availableToRedeem < points.pointsBalance ? (
                      <><GreenTooltip title={t('Points may only apply to eligible invoices made within the last 90 days. The redemption value may not exceed 50% of the eligible invoice amount.')} placement="bottom" arrow>
                        <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: 3 }} />
                      </GreenTooltip></>
                    ) : null}
                  </div>
                </div>
                <div style={{ fontSize: 20, fontWeight: "bold" }}>
                  {points?.availableToRedeem > 0 ? pointsFormat(points?.availableToRedeem) : 0}
                </div>
              </div>
            </div> */}

                   
            
              {/* {(loyaltyActive && !redeembtnConditionForBronze) && (
                <div
                className={classes.redeemDiv}
                onClick={handleRedeemClick}
                style={{
                  cursor:  "pointer",
                  opacity: 1
                }}
              >
                {t("Redeem").toUpperCase()}
              </div>
              )} */}
          </div> : <div
            style={{
              display: "flex",
              height: "47px",
              marginTop: "10px",
              justifyContent: 'center'
            }}
          >
            {loyaltyActive && !redeembtnConditionForBronze && (
              <div
                className={classes.redeemDivForCanada}
                onClick={handleRedeemClick} // <-- track click here as well
              >
                {t('Redeem').toUpperCase()}
              </div>
            )}
          </div>}
        </Grid>
      </Grid>
    </div>
  );
}
